export enum AnnualBonusType {
  NONE = 'NONE',
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
}
